import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Form } from "./Form";
import { Gracias } from "./Gracias";
import { Admin } from "./Admin";
import "./styles.css";

const container = document.getElementById("root");
if (!container) throw new Error("root not found");

ReactDOM.createRoot(container).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Form />} />
        <Route path="/contacto" element={<Form />} />
        <Route path="/gracias/:token" element={<Gracias />} />
        <Route path="/admin/leads" element={<Admin />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
